import gql from "graphql-tag";

export const MY_TIME_REQUESTS_SUBSCRIPTION = gql`
  subscription myTimeRequestsSubscription {
    myTimeRequestsSubscription
  }
`;
